module.exports = __webpack_public_path__ + "img/logo-school-6.577098a1.png";